import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatDatepickerInputEvent,
  MatPaginator,
  PageEvent,
  MatDialog,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import { ActivatedRoute, Router } from "@angular/router";
import { BetInfo, GameReportByCompetition } from "src/_models";
import { ConvertUpochToDate } from "src/_helpers/utils";
import { Location } from "@angular/common";
import { BetDetailsModalComponent } from "../../bet-list/bet-list.component";

@Component({
  selector: "gm-report-market-level",
  templateUrl: "./gr-market-level.component.html",
  styleUrls: ["../game-report.component.scss"],
})
export class GmRepMarketLevelComponent implements OnInit {
  datalistDisplayedColumns: string[] = [
    "PlaceDate",
    "MarketName",
    "BetOn",
    "OddValue",
    "StakeAmount",
    "Returns",
    "Status",
    "ResultTime",
  ];
  providers: any = [];
  datalist = new MatTableDataSource<GameReportByCompetition>();
  selectedUser: { userId: string; userName: string };
  selectedUserName = "";
  selected: any = { startDate: 0, endDate: 0 };
  filterUsers = [];
  users = [];

  providerId = "";
  userId: string = "";
  selectedUserId = "";
  sportId: string = null;
  operatorId = "";
  origin = [];
  prTitle = "";
  category = "";
  subProvider = "";
  sportName = null;
  eventId = null;
  marketId = null;
  marketName = null;
  eventName = null;
  competitionId: any;
  userName: any;
  competitionName: any;
  length: any = 0;
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  page = 1;
  pageSize = 25;
  orgPageSize = 25;

  constructor(
    private appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.providerId = this.activatedRoute.snapshot.params.providerId;
    this.sportId = this.activatedRoute.snapshot.params.sportId;
    this.eventId = this.activatedRoute.snapshot.params.eventId;
    this.marketId = this.activatedRoute.snapshot.params.marketId;
    this.userId = this.activatedRoute.snapshot.params.userId;
    // this.operatorId = this.activatedRoute.snapshot.params.operatorId;
    this.competitionId = this.activatedRoute.snapshot.params.competitionId;
    this.userName = this.activatedRoute.snapshot.params.userName;

    this.activatedRoute.queryParams.subscribe((params) => {
      this.selected = {
        startDate:
          params.startTime !== "0"
            ? new Date(params.startTime * 1000)
            : new Date(),
        endDate:
          params.endTime !== "0" ? new Date(params.endTime * 1000) : new Date(),
      };

      this.providerId = params["providerId"];
      this.competitionName = params["competitionName"];
      this.sportName = params["sportName"];
      this.eventName = params["eventName"];
      this.origin = params["origin"];
      this.category = params["category"];
      this.subProvider = params["subProvider"];
      this.operatorId = params["operatorId"];
      this.marketName = params["marketName"];
      this.userName = params["userName"];
      this.selectedUserId = params["userId"];
      if (this.providerId && this.sportId) {
        this.getReportData();
      }
      let lowerCaseOrigins = this.origin.map(item => item.toLowerCase());
    this.prTitle = lowerCaseOrigins.length > 0 ? lowerCaseOrigins.join(', ') : "";
    });
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  goBackToCompLevel = () => {
    this.router.navigate(
      [
        `reports/game_report/${this.providerId}/${this.sportId}/${this.competitionId}`,
      ],
      {
        queryParams: {
          operatorId: this.operatorId,
          providerId: this.providerId,
          sportId: this.sportId,
          sportName: this.sportName,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          competitionName: this.competitionName,
          competitionId: this.competitionId,
          userId: this.selectedUserId,
          userName: this.userName ? this.userName : "",

          startTime:
            this.selected.startDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.startDate).getTime() / 1000).toFixed(
                    0
                  )
                ),
          endTime:
            this.selected.endDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
                ),
        },
      }
    );
  };

  goBackEventLevel = () => {
    this.router.navigate(
      [
        `reports/game_report/${this.providerId}/${this.sportId}/${this.competitionId}/${this.eventId}`,
      ],
      {
        queryParams: {
          providerId: this.providerId,
          sportId: this.sportId,
          eventName: this.eventName,
          sportName: this.sportName,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          competitionName: this.competitionName,
          operatorId: this.operatorId,
          userId: this.selectedUserId,
          userName: this.userName ? this.userName : "",
          startTime:
            this.selected.startDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.startDate).getTime() / 1000).toFixed(
                    0
                  )
                ),
          endTime:
            this.selected.endDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
                ),
        },
      }
    );
  };

  goBackToSportLevel = () => {
    this.router.navigate(
      [`reports/game_report/${this.providerId}/${this.sportId}`],
      {
        queryParams: {
          providerId: this.providerId,
          userId: this.selectedUserId,
          sportId: this.sportId,
          sportName: this.sportName,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          userName: this.userName,
          operatorId: this.operatorId,
          startTime:
            this.selected.startDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.startDate).getTime() / 1000).toFixed(
                    0
                  )
                ),
          endTime:
            this.selected.endDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
                ),
        },
      }
    );
  };

  goBackToUserLevel = () => {
    let startDate, endDate;
    this.activatedRoute.queryParams.subscribe((params) => {
      (startDate = params.startTime), (endDate = params.endTime);
    });

    this.router.navigate(
      [
        `reports/game_report/${this.providerId}/${this.sportId}/${this.competitionId}/${this.eventId}/${this.marketId}`,
      ],
      {
        queryParams: {
          providerId: this.providerId,
          eventName: this.eventName,
          marketName: this.marketName,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          userName: this.userName ? this.userName : "",
          // sportId: this.sportId,
          operatorId: this.operatorId,
          sportName: this.sportName,
          competitionId: this.competitionId,
          competitionName: this.competitionName,
          userId: this.selectedUserId,
          startTime:
            startDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.startDate).getTime() / 1000).toFixed(
                    0
                  )
                ),
          endTime:
            endDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
                ),
        },
      }
    );
  };

  goBackToProviderLevel = () => {
    this.router.navigate([`reports/game_report/${this.providerId}`], {
      queryParams: {
        providerId: this.providerId,
        userId: this.selectedUserId,
        operatorId: this.operatorId,
        userName: this.userName ? this.userName : "",
        origin: this.origin ? this.origin : [],
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        startTime:
          this.selected.startDate !== null
            ? new Date(this.selected.startDate).getTime() / 1000
            : 0,
        endTime:
          this.selected.endDate !== null
            ? new Date(this.selected.endDate).getTime() / 1000
            : 0,
      },
    });
  };

  goBackToGameLevel = () => {
    this.router.navigate([`reports/game_report/`]);
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.startDate !== null) {
      this.getReportData();
    }
  };

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getReportData();
  }

  getReportData = () => {
    try {
      let filters = {
        // userId: this.selectedUser ? this.selectedUser.userId : null,
        providerId: this.providerId,
        eventId: this.eventId,
        marketId: this.marketId,
        userId: this.userId ? this.userId : "",
        operatorId: this.operatorId,
        origin: this.origin ? this.origin : [],
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        competitionId: this.competitionId,
        sportId: this.sportId,
        startTime:
          this.selected.startDate !== null
            ? new Date(this.selected.startDate).getTime() / 1000
            : 0,
        endTime:
          this.selected.endDate !== null
            ? new Date(this.selected.endDate).getTime() / 1000
            : 0,
        pageSize: this.orgPageSize,
        page: this.page,
      };

      this.appService.getMarketPLData(filters).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.datalist = new MatTableDataSource<GameReportByCompetition>(
            res.sportReport[0].bets
          );
          if (this.page == 1) {
            this.length = res.totalBets;
          } else {
            this.paginator.length = this.length;
          }
        }
      });
    } catch (err) {}
  };

  formatDate(date) {
    return ConvertUpochToDate(date);
  }

  openDialog(betDetails: BetInfo) {
    this.dialog.open(BetDetailsModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        betInfo: betDetails,
      },
    });
  }
  
}
